import * as url from "../../helpers/url_helper";
import { apiCall } from "./apiService";

/**
 * Loads platforms from API with error handling
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Array|null>} Array of platforms or null if error
 */
export const loadPlatformsData = async (notifyError) => {
    return await apiCall(
        url.GET_PLATFORM,
        'GET',
        null,
        notifyError,
        "Failed to load platforms"
    );
};

/**
 * Fetches tokens for a platform
 * @param {string} email - Platform email
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Token data or null if error
 */
export const fetchPlatformTokens = async (email, notifyError) => {
    return await apiCall(
        url.POST_TOKEN,
        'POST',
        { email },
        notifyError,
        "Failed to fetch tokens"
    );
};

/**
 * Creates a new platform
 * @param {Object} platformData - Platform data (name, email, username, password)
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Created platform data or null if error
 */
export const createPlatform = async (platformData, notifyError) => {
    return await apiCall(
        url.POST_REGISTER,
        'POST',
        platformData,
        notifyError,
        "Platform Creation failed"
    );
};

/**
 * Updates an existing platform
 * @param {Object} platformData - Platform data (id, name, username, password)
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Updated platform data or null if error
 */
export const updatePlatform = async (platformData, notifyError) => {
    return await apiCall(
        url.PUT_PLATFORM,
        'PUT',
        platformData,
        notifyError,
        "Platform Update failed"
    );
};

